import { createRouter, createWebHistory } from "vue-router";
import store from "./store"; // import your store
import Home from "./components/Home.vue";
import Careering from "./components/Careering.vue";
import Role from "./components/Role.vue";
import NotFound from "./components/NotFound.vue";
import Support from "./components/Support.vue";
import Invite from "./components/Invite";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import CopyrightDisputePolicy from "./components/CopyrightDisputePolicy";

import Waitlist from "./components/Pages/Waitlist";
import Landing from "./components/Pages/Landing";
import USBs from "./components/Pages/USBs";
import Lore from "./components/Pages/Lore";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Landing
  },
  {
    path: "/atm",
    name: "ATM",
    component: Home
  },
  {
    path: "/careering",
    name: "Careering",
    component: Careering
  },
  {
    path: "/careering/:role",
    name: "Role",
    component: Role
  },
  {
    path: '/sample-7',
    name: 'Classic USB',
    component: USBs,
  },
  {
    path: '/classic',
    name: 'Classic USB',
    component: USBs,
  },
  {
    path: '/transport',
    name: "Transport",
    component: USBs,
  },
  {
    path: "/support",
    name: "Support",
    component: Support
  },
  {
    path: "/invite",
    name: "Invite",
    component: Invite,
    props: route => ({ code: route.query.code })
  },
  {
    path: "/waitlist",
    name: "Waitlist",
    component: Waitlist,
  },
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    component: PrivacyPolicy,
  },
  {
    path: "/terms",
    name: "Terms of Service",
    component: TermsOfService,
  },
  {
    path: "/copyright-dispute",
    name: "Copyright Dispute Policy",
    component: CopyrightDisputePolicy,
  },
  {
    path: "/about",
    name: "About",
    component: Lore,
  },

  // catch-all 404
  { path: "/:catchAll(.*)", name: "NotFound", component: NotFound }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  store.commit("setPreviousRoute", from); // Commit mutation to set previous route
  next();
});

export default router;
